function countdownTimer(el) {
  let spanEls = el.querySelectorAll("span"),
    x = setInterval(function () {
      let distance = new Date(el.dataset.end).getTime() - new Date().getTime(),
        days = Math.floor(distance / (1000 * 60 * 60 * 24)),
        hours = Math.floor(
          (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        ),
        minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60)),
        seconds = Math.floor((distance % (1000 * 60)) / 1000);

      spanEls.forEach((spanEl, index) => {
        switch (index) {
          case 0: {
            if (days < 10) {
              spanEl.innerHTML = "0" + days;
            } else {
              spanEl.innerHTML = days;
            }
            break;
          }
          case 1: {
            if (hours < 10) {
              spanEl.innerHTML = "0" + hours;
            } else {
              spanEl.innerHTML = hours;
            }
            break;
          }
          case 2: {
            if (minutes < 10) {
              spanEl.innerHTML = "0" + minutes;
            } else {
              spanEl.innerHTML = minutes;
            }
            break;
          }
          case 3: {
            if (seconds < 10) {
              spanEl.innerHTML = "0" + seconds;
            } else {
              spanEl.innerHTML = seconds;
            }
            break;
          }
        }
      });

      if (distance < 0) {
        clearInterval(x);
        spanEls.forEach((spanEl) => {
          spanEl.innerHTML = "00";
        });
      }
    }, 1000);
}

function countdownInit() {
  let countdownEls = document.querySelectorAll(".jsCountdown");
  if (countdownEls) {
    countdownEls.forEach((countdownEl) => {
      countdownTimer(countdownEl);
    });
  }
}

window.addEventListener("load", (e) => {
  countdownInit();
});
